import styled from "styled-components";

export const StyledTaskPromoTag = styled.div<{ $isActive: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};

    background: ${({ theme, $isActive }) =>
        $isActive ? theme.tabsAPBackground : "transparent"};
`;

export const StyledCommentIndicator = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
`;
